import api from "./api";

export async function setEmail (data) {
    return api.post(`/emails`, data).then(response => console.log(response))
}

export async function sendEmail (data) {
    return api.post(`/emails`, data)
}

export function sendNotificationOverdue(status) {
    return api.post(`/emails/overdue`, {'status': status})
        .then(response => response.data)
        .catch(error => console.log(error));
}

export function sendNotificationComment(data) {
    return api.post(`/emails/comment`, data)
        .then(response => response.data)
        .catch(error => console.log(error));
}
